import {StockValueByMusicSystemBrandTypes } from './actionTypes'

//grid
export const getStockValueByMusicSystemBrandLoading = (lazyState: any) => {
  return {
    type: StockValueByMusicSystemBrandTypes.GET_STOCK_VALUE_BY_MUSIC_SYSTEM_BRAND_LIST_LOADING,
    lazyState,
  };
};
export const getStockValueByMusicSystemBrandSuccess = (stockvalueList : any) => {
  return {
    type: StockValueByMusicSystemBrandTypes.GET_STOCK_VALUE_BY_MUSIC_SYSTEM_BRAND_LIST_SUCCESS,
    payload : stockvalueList   
  };
};
export const getStockValueByMusicSystemBrandError = (error : any) => {
  return {
    type: StockValueByMusicSystemBrandTypes.GET_STOCK_VALUE_BY_MUSIC_SYSTEM_BRAND_LIST_ERROR,
    payload : error
  };
};

export const getAudioBrandLoading = () => {
  return {
    type: StockValueByMusicSystemBrandTypes.GET_AUDIO_BRAND_LOADING,
  };
};
export const getAudioBrandSuccess = (stockvalueList : any) => {
  return {
    type: StockValueByMusicSystemBrandTypes.GET_AUDIO_BRAND_SUCCESS,
    payload : stockvalueList   
  };
};
export const getAudioBrandError = (error : any) => {
  return {
    type: StockValueByMusicSystemBrandTypes.GET_AUDIO_BRAND_ERROR,
    payload : error
  };
};
